import React, { useState, useEffect, useRef } from "react";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import { makeStyles } from "@material-ui/core/styles";
import { Autocomplete } from "@mui/material";
import TextField from "@mui/material/TextField";

// import "./MultiselectList.scss";
import MultiSelectList from "../../SearchManager/MultiSelectList";

import blueDownArrow from "../../../images/gilead- collapse-dropdown.svg";
import grayDownArrow from "../../../images/gilead- collapse-dropdown.svg";
import blueUpArrow from "../../../images/gilead- collapse-dropdown.svg";
import dropdownArrow from "../../../images/gilead- collapse-dropdown.svg";
import DisabledBackArrowicon from "../../../images/gilead-disabled-dropdown-arrow.svg";
import "../../SearchManager/MultiselectDropDown.scss";
import "../SelectAutoComplete/selectAutocomplete.scss";
import FooterButtons from "../../SearchManager/FooterButtons";
import PrimaryButton from "../../SearchManager/PrimaryButton";
import { ClickAwayListener } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    // zIndex: "9999",
    display: "inline-block",
  },
  paper: {
    marginRight: theme.spacing(2),
  },
}));

const MultiSelectDropdown = ({
  title,
  data,
  applySelection,
  disabled = false,
  selectedFilterData,
  setIsSearchBarEmpty,
  values,
  multiple,
  setCreatePresentationFields,
  createPresentationFields,
  getSearchCriteria,
  searchExpand,
  isPdfFlow = false,
  label,
  required = false,
}) => {
  const [isOpen, toggleisOpen] = useState(false);
  const [selectedData, setSelectedData] = useState({
    product: [],
    country: [],
    mlrStatus: [],
    indication: [],
  });
  const classes = useStyles();
  const anchorRef = useRef(null);
  const [initialLoad, toggleInitialLoad] = useState(true);
  const [filteredList, setFilteredList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [displayValue, setDisplayValue] = useState(""); // Always initialize as empty string, never undefined

  const handleToggle = () => {
    toggleisOpen((prevOpen) => !prevOpen);
  };

  // Sync selectedFilterData to internal state when it changes (for display)
  useEffect(() => {
    const titleLower = title.toLowerCase();
    // Always compute display value from selectedFilterData
    if (
      selectedFilterData &&
      Array.isArray(selectedFilterData) &&
      selectedFilterData.length > 0
    ) {
      setSelectedData((prev) => ({
        ...prev,
        [titleLower]: selectedFilterData,
      }));
      // Update display value immediately - compute it directly
      let computedValue = "";
      if (selectedFilterData.length > 1) {
        const names = selectedFilterData
          .map((item) => {
            if (item && typeof item === "object") {
              return item.name || item._id || item.id || "";
            }
            return item || "";
          })
          .filter((name) => name);
        computedValue = names.join(", ");
      } else {
        const firstItem = selectedFilterData[0];
        if (firstItem && typeof firstItem === "object") {
          computedValue = firstItem.name || firstItem._id || firstItem.id || "";
        } else {
          computedValue = firstItem || "";
        }
      }
      // Always update displayValue - force update
      setDisplayValue(computedValue);
      console.log(
        "MultiSelectDropdown - Setting displayValue:",
        computedValue,
        "from selectedFilterData:",
        selectedFilterData
      );
    } else if (
      selectedFilterData &&
      Array.isArray(selectedFilterData) &&
      selectedFilterData.length === 0
    ) {
      // Clear if empty array is passed
      setSelectedData((prev) => ({
        ...prev,
        [titleLower]: [],
      }));
      setDisplayValue("");
    } else {
      // Clear if selectedFilterData is null/undefined or empty
      setDisplayValue("");
    }
  }, [selectedFilterData, title]);

  // console.log(selectedFilterData)
  //   useEffect(() => {
  //   setSelectedData(prev => ({
  //     ...prev,
  //     product: selectedFilterData
  //   }));
  // }, [selectedFilterData]);

  const handleClose = (event) => {
    toggleisOpen(false);
  };

  const handleSelection = (isChecked, element, title) => {
    const titleLower = title.toLowerCase();
    toggleInitialLoad(false);
    setSelectedData((prev) => {
      const currentList = prev[titleLower] || [];
      const isSelected = currentList.some(
        (i) =>
          (i?._id && element?._id && i._id === element._id) ||
          (i?.id && element?.id && i.id === element.id) ||
          (i?.name && element?.name && i.name === element.name) ||
          i === element
      );

      const updatedList = isSelected
        ? currentList.filter(
            (i) =>
              !(
                (i?._id && element?._id && i._id === element._id) ||
                (i?.id && element?.id && i.id === element.id) ||
                (i?.name && element?.name && i.name === element.name) ||
                i === element
              )
          )
        : [...currentList, element];

      return {
        ...prev,
        [titleLower]: updatedList,
      };
    });
  };
  const clearSelection = () => {
    // setSelectedData(() => {
    //   return [];
    // });
    setSelectedData({
      product: [],
      country: [],
      mlrStatus: [],
      indication: [],
    });
    // getSearchCriteria([], "Product");
    enableDisableApplyButton();
    // applySelection(undefined);
  };

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(isOpen);
  useEffect(() => {
    if (prevOpen.current === true && isOpen === false) {
      const titleLower = title.toLowerCase();
      // Sync selectedFilterData to internal state when closing
      setSelectedData((prev) => ({
        ...prev,
        [titleLower]: selectedFilterData || [],
      }));
      setSearchText("");
      if (anchorRef.current) {
        anchorRef.current.focus();
      }
    }

    prevOpen.current = isOpen;
    // Enable/disable apply button
    if (!isOpen) {
      toggleInitialLoad(true);
    } else {
      toggleInitialLoad(isOpen && (selectedFilterData || [])?.length === 0);
    }
  }, [isOpen, title, selectedFilterData]);

  const enableDisableApplyButton = () => {
    if (!isOpen) {
      toggleInitialLoad(true);
      return;
    }
    toggleInitialLoad(isOpen && (selectedFilterData || [])?.length === 0);
  };

  const applyButton = (
    <PrimaryButton
      title="Apply"
      handleClick={() => {
        getSearchCriteria(selectedData[title.toLowerCase()], title);
        // applySelection(selectedData);
        handleClose();
      }}
      disabled={selectedData[title.toLowerCase()]?.length === 0 || initialLoad} //&& values?.brand.length === 0
      customClass={
        selectedData[title.toLowerCase()]?.length > 0 ? "activeApply" : ""
      }
    />
  );
  const clearButton = (
    <div
      //title="Clear"
      onClick={() => {
        clearSelection();
      }}
      className={
        selectedData[title.toLowerCase()]?.length > 0
          ? "clearbtnEnable"
          : "clearbtnDisable"
      }
      disabled={
        !selectedData[title.toLowerCase()] ||
        selectedData[title.toLowerCase()].length === 0
      }
    >
      Clear
    </div>
  );

  const getArrow = () => {
    if (isOpen) {
      return blueUpArrow;
    } else if (disabled) {
      return grayDownArrow;
    }
    return blueDownArrow;
  };

  useEffect(() => {
    setFilteredList(data || []);
  }, [data]);

  useEffect(() => {
    if (!data) {
      return;
    }
    let filterData = [...data];

    // Filter by Search Input
    if (searchText && searchText?.trim()) {
      const searchLower = searchText.toLowerCase();
      filterData = filterData.filter((item) => {
        const listItem = item.name || item;
        return listItem.toLowerCase().includes(searchLower);
      });
    }
    setFilteredList(filterData);
  }, [searchText, data]);

  const autocompleteContainerRef = useRef(null);
  const getDisplayValue = () => {
    // Check selectedFilterData first (from props)
    // Debug: Log to see what we're getting
    if (
      selectedFilterData &&
      Array.isArray(selectedFilterData) &&
      selectedFilterData.length > 0
    ) {
      // For multiple selections, show all selected values
      if (selectedFilterData.length > 1) {
        const names = selectedFilterData
          .map((item) => {
            if (item && typeof item === "object") {
              return item.name || item._id || item.id || "";
            }
            return item || "";
          })
          .filter((name) => name);
        return names.join(", ");
      } else {
        // Single selection
        const firstItem = selectedFilterData[0];
        if (firstItem && typeof firstItem === "object") {
          return firstItem.name || firstItem._id || firstItem.id || "";
        }
        return firstItem || "";
      }
    }
    // Fallback to internal selectedData state
    const titleLower = title.toLowerCase();
    if (
      selectedData[titleLower] &&
      Array.isArray(selectedData[titleLower]) &&
      selectedData[titleLower].length > 0
    ) {
      if (selectedData[titleLower].length > 1) {
        const names = selectedData[titleLower]
          .map((item) => {
            if (item && typeof item === "object") {
              return item.name || item._id || item.id || "";
            }
            return item || "";
          })
          .filter((name) => name);
        return names.join(", ");
      } else {
        const firstItem = selectedData[titleLower][0];
        if (firstItem && typeof firstItem === "object") {
          return firstItem.name || firstItem._id || firstItem.id || "";
        }
        return firstItem || "";
      }
    }
    return "";
  };

  // PDF Flow: Use Autocomplete button like Product/Country
  if (isPdfFlow) {
    return (
      <div
        className={`filterContainer ${classes.root}`}
        style={{
          pointerEvents: searchExpand ? "none" : "",
          width: "100%",
        }}
      >
        <div ref={autocompleteContainerRef} style={{ width: "100%" }}>
          <Autocomplete
            disablePortal
            disableClearable
            id={`multi-select-${title.toLowerCase()}`}
            className={`autocomplete-select-custom ${
              disabled ? "desabled-dropdown-css" : ""
            }`}
            sx={{
              width: "100%",
              "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                fontSize: "12px",
                color: "#66676b",
                borderColor: "none",
                outline: "none",
              },
              "& .MuiOutlinedInput-root": {
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#DDDFDD",
                },
              },
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "#DDDFDD",
                  outline: "none",
                  borderWidth: "1px",
                },
              "& .MuiInputBase-root": {
                width: "100%",
              },
            }}
            popupIcon={
              <img
                src={data.length < 1 ? DisabledBackArrowicon : dropdownArrow}
                width={13}
                height={8}
                alt=""
              />
            }
            open={false}
            onOpen={() => {
              if (!disabled && !searchExpand) {
                handleToggle();
              }
            }}
            onClose={() => {
              // Prevent Autocomplete from closing - we handle it with our custom Popper
            }}
            options={[]}
            value={null}
            inputValue={
              isOpen
                ? searchText || ""
                : displayValue || getDisplayValue() || ""
            }
            onInputChange={(event, newInputValue, reason) => {
              // Only update searchText when dropdown is open and user is typing
              if (isOpen && reason === "input") {
                setSearchText(newInputValue || "");
              }
            }}
            disabled={disabled}
            fullWidth={true}
            size="small"
            renderInput={(params) => {
              // Override the input value from params to use our controlled value
              // Always ensure it's a string to avoid controlled/uncontrolled warning
              const currentValue = isOpen
                ? searchText || ""
                : displayValue || getDisplayValue() || "";
              return (
                <TextField
                  {...params}
                  label={
                    <span>
                      {label || title}{" "}
                      {required ? <span className="required">*</span> : ""}
                    </span>
                  }
                  placeholder={displayValue ? "" : "Search & Select"}
                  name={label || title}
                  value={currentValue}
                  onChange={(e) => {
                    if (isOpen) {
                      setSearchText(e.target.value);
                    } else {
                      // Prevent changes when not open - value is controlled
                      e.preventDefault();
                    }
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!disabled && !searchExpand && !isOpen) {
                      handleToggle();
                    }
                  }}
                  onFocus={(e) => {
                    e.stopPropagation();
                    if (!disabled && !searchExpand && !isOpen) {
                      handleToggle();
                    }
                  }}
                  InputProps={{
                    ...params.InputProps,
                    readOnly: !isOpen,
                  }}
                  InputLabelProps={{
                    ...params.InputLabelProps,
                  }}
                />
              );
            }}
            componentsProps={{
              popper: {
                anchorEl: null,
                placement: "bottom-start",
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [0, 4],
                    },
                  },
                ],
              },
            }}
            renderOption={() => null}
            ListboxComponent={() => null}
            ListboxProps={{
              style: { display: "none" },
            }}
          />
        </div>
        <Popper
          open={isOpen && !searchExpand}
          anchorEl={autocompleteContainerRef.current}
          role={undefined}
          transition
          disablePortal
          className="multi-select-dropdown-outer"
          placement="bottom-start"
        >
          {({ TransitionProps }) => (
            <Grow {...TransitionProps}>
              <Paper className="paper-comp">
                <ClickAwayListener onClickAway={handleClose}>
                  <div>
                    <MultiSelectList
                      data={filteredList}
                      anchorRef={autocompleteContainerRef}
                      open={true}
                      handleSelection={handleSelection}
                      selected={selectedData}
                      height="200px"
                      searchResults={(value) => setSearchText(value)}
                      inputValue={searchText}
                      setIsSearchBarEmpty={setIsSearchBarEmpty}
                      multiple={multiple}
                      handleClose={handleClose}
                      title={title}
                      isPdfFlow={isPdfFlow}
                    />
                    {multiple && (
                      <FooterButtons
                        primaryButton={applyButton}
                        secondaryButton={clearButton}
                        size="sm"
                      />
                    )}
                  </div>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    );
  }

  // Dashboard: Use original button style
  return (
    <div
      className={`filterContainer ${classes.root}`}
      style={{ pointerEvents: searchExpand ? "none" : "" }}
    >
      <div
        className={`btn multiselect-dropdown ${isOpen ? "active" : ""} ${
          disabled ? "disabled" : ""
        }`}
        ref={anchorRef}
        aria-controls={isOpen ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        disabled={disabled}
        onClick={() => {
          if (disabled || searchExpand) {
            return;
          } else {
            handleToggle();
          }
        }}
      >
        {" "}
        {title}
        <img
          src={getArrow()}
          alt=""
          style={{ marginLeft: "4px", height: "6px", width: "9px" }}
        />
      </div>
      <Popper
        open={isOpen && !searchExpand}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        className="multi-select-dropdown-outer"
        placement="bottom-end"
      >
        {/*  */}
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper className="paper-comp">
              <ClickAwayListener onClickAway={handleClose}>
                <div>
                  <MultiSelectList
                    data={filteredList}
                    anchorRef={anchorRef}
                    open={true}
                    handleSelection={handleSelection}
                    selected={selectedData}
                    height="200px"
                    searchResults={(value) => setSearchText(value)}
                    inputValue={searchText}
                    setIsSearchBarEmpty={setIsSearchBarEmpty}
                    multiple={multiple}
                    handleClose={handleClose}
                    title={title}
                  />
                  {multiple && (
                    <FooterButtons
                      primaryButton={applyButton}
                      secondaryButton={clearButton}
                      size="sm"
                    />
                  )}
                </div>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
};

export default MultiSelectDropdown;
